import React from 'react';
import map from 'lodash/map';
import swal from 'sweetalert2';
import classNames from 'classnames';
import orderBy from 'lodash/orderBy';
import isEmpty from 'lodash/isEmpty';
import {connect} from 'react-redux';

import Loader from '../../../../../components/Loader';
import Filters from '../../../../../components/Filters';

import FilterInput from '../../../../../components/Filters/Input';

import {
  fetchCalendarByDivisionByGameWeekNumber,
  fetchCalendarByDivision,
} from '../../../../../actions/entities/league';

import './index.css';

const cols = {
  homeUser: 'Home User',
  homeName: 'Home Name',
  homeScore: 'Home Score',
  awayScore: 'Away Score',
  awayName: 'Away Name',
  awayUser: 'Away User',
};

class SupportLeagueCalendarWidget extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      filters: {
        divisionId: props.divisionId || '',
        gameWeekNumber: 1,
        totalGameWeeks: undefined,
      },
      order: {key: 'id', value: 'asc'},
      isFetching: false,
      highlightRefreshBtn: true,
    };
  }

  componentDidUpdate(_prevProps, prevState) {
    if (
      prevState.filters.gameWeekNumber !== this.state.filters.gameWeekNumber
    ) {
      this.props.dispatch(
        fetchCalendarByDivisionByGameWeekNumber(
          {
            divisionId: this.state.filters.divisionId,
            gameWeekNumber: this.state.filters.gameWeekNumber,
          },
          {},
        ),
      );
    }
  }

  updateFilters(filter) {
    this.setState({filters: {...this.state.filters, ...filter}});
  }

  notifyRefresh(value) {
    const {highlightRefreshBtn} = this.state;
    this.setState({
      highlightRefreshBtn: value !== undefined ? value : !highlightRefreshBtn,
    });
  }

  selectOrChangeOrder(key) {
    if (key === this.state.order.key)
      this.setState({
        order: {key, value: this.state.order.value === 'asc' ? 'desc' : 'asc'},
      });
    else {
      const newOrder = {key};
      // The switch is necessary for the default sortOrder each orderType
      switch (key) {
        case 'id':
          newOrder.value = 'asc';
          break;
        default:
          newOrder.value = 'desc';
      }
      this.setState({order: newOrder});
    }
  }

  onError = error => {
    this.setState({isFetching: false});
    swal({
      title: `Oops...`,
      type: 'error',
      html:
        `Something went wrong !<br/>${error}<br/>` +
        `<pre><code>${JSON.stringify(error, undefined, 4)}</code></pre>`,
    });
  };

  fetchData(divisionId = this.state.filters.divisionId) {
    if (!this.state.isFetching && !isEmpty(divisionId)) {
      const payload = {
        divisionId,
        gameWeekNumber: this.state.filters.gameWeekNumber,
      };
      this.props.dispatch(fetchCalendarByDivisionByGameWeekNumber(payload, {}));
      this.props.dispatch(
        fetchCalendarByDivision({
          divisionId,
          onSuccess: response =>
            this.setState({
              filters: {
                ...this.state.filters,
                totalGameWeeks: response.divisionCalendar.fixtures.length,
              },
            }),
        }),
      );
    }
  }

  renderTable() {
    const {order} = this.state;
    const {data} = this.props;

    if (isEmpty(data) || (!isEmpty(data) && !data.matches.length))
      return <p className="text-center px-3 pb-3">No data to show</p>;

    return (
      <div className="table-responsive">
        <table className="table table-striped">
          <thead>
            <tr>{this.renderThs(cols)}</tr>
          </thead>
          <tbody>
            {orderBy(
              data.matches,
              [order.key, 'id'],
              [order.value, 'desc'],
            ).map((t, i) =>
              this.renderTr(
                {
                  ...t,
                  homeName: data.teamsByTeamId[t.home.teamId].name,
                  awayName: data.teamsByTeamId[t.away.teamId].name,
                },
                i,
              ),
            )}
          </tbody>
        </table>
      </div>
    );
  }

  renderTr(o, key, onClick) {
    const winner =
      o.home.score === o.away.score
        ? 'draw'
        : o.home.score > o.away.score
        ? 'home'
        : 'away';

    return (
      <tr key={key} onClick={onClick} role={onClick ? 'button' : 'default'}>
        <td>{o.home.userId}</td>
        <td className={classNames({'text-bold': winner === 'home'})}>
          {o.homeName}
        </td>
        <td className={classNames({'text-bold': winner === 'home'})}>
          {o.home.score || '-'}
        </td>
        <td className={classNames({'text-bold': winner === 'away'})}>
          {o.away.score || '-'}
        </td>
        <td className={classNames({'text-bold': winner === 'away'})}>
          {o.awayName}
        </td>
        <td>{o.away.userId}</td>
      </tr>
    );
  }

  renderThs(cols, hideSort = false) {
    const {order} = this.state;
    return map(cols, (value, key) => (
      <th key={key}>
        <span
          onClick={() => !hideSort && this.selectOrChangeOrder(key)}
          className={classNames('orderBtn', {
            'text-primary': order.key === key && !hideSort,
          })}>
          {value}
          {value && (
            <span className={classNames('ml-1', {hidden: hideSort})}>
              <i
                className={classNames('fa', {
                  'fa-sort': order.key !== key,
                  [`fa-sort-${order.value}`]: order.key === key,
                })}
              />
            </span>
          )}
        </span>
      </th>
    ));
  }

  getSelectOptions = totalGameWeeks => {
    const options = [];
    for (let i = 1; i <= totalGameWeeks; i++) {
      options.push(<option value={i}>{i}</option>);
    }
    return options.map(option => option);
  };

  render() {
    const {
      isFetching,
      highlightRefreshBtn,
      filters: {totalGameWeeks, gameWeekNumber},
    } = this.state;
    const {data} = this.props;

    return (
      <div id="support-league-calendar-widget">
        <div className="box">
          <div className="box-header with-border">
            <h3 className="box-title pull-left">
              <i className="fa fa-calendar" />
              {` Calendar`}
            </h3>
          </div>
          <div className="box-body">
            <Filters
              childrenStyle={{
                display: 'flex',
                alignItems: 'flex-end',
                justifyContent: 'center',
              }}>
              <FilterInput
                label="DivisionId:"
                onChange={divisionId => {
                  this.updateFilters({divisionId});
                  this.notifyRefresh(true);
                }}
                initialValue={this.state.filters.divisionId}
                inputProps={{
                  type: 'text',
                  placeholder: 'L3FA9BR4',
                  value: this.state.filters.divisionId,
                }}
              />
              {totalGameWeeks && !isEmpty(data) && (
                <select
                  className="form-control"
                  onChange={event =>
                    this.updateFilters({
                      gameWeekNumber: parseInt(event.target.value, 10),
                    })
                  }
                  value={gameWeekNumber}>
                  {this.getSelectOptions(totalGameWeeks)}
                </select>
              )}
              <button
                onClick={() => this.fetchData()}
                style={{marginTop: '25px'}}
                className={classNames('btn', {
                  'btn-primary': highlightRefreshBtn,
                  'btn-default': !highlightRefreshBtn,
                })}>
                <i className="fa fa-search" />
              </button>
            </Filters>
          </div>
          {isFetching && <Loader />}
          <div className="body-table">{this.renderTable()}</div>
        </div>
      </div>
    );
  }
}

export default connect(
  state => ({
    data: state.app.support.leagueCalendar,
  }),
  dispatch => ({dispatch}),
)(SupportLeagueCalendarWidget);



// WEBPACK FOOTER //
// ./src/pages/Support/League/Widgets/LeagueCalendar/index.js